import axios, { AxiosInstance, InternalAxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';
import { getAuthHeader, logout } from './auth.service';
import { ApiResponse, ErrorResponse } from '../types';

const API_URL = process.env.REACT_APP_API_URL as string;

// Create axios instance
const apiService: AxiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor
apiService.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // Add auth header to every request if user is logged in
    const authHeader = getAuthHeader();
    if (authHeader.Authorization && config.headers) {
      config.headers.Authorization = authHeader.Authorization;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// Add response interceptor
apiService.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError<ErrorResponse>) => {
    // Handle 401 Unauthorized errors (token expired)
    if (error.response && error.response.status === 401) {
      // Logout user and redirect to login page
      logout();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default apiService;
